import { cva } from 'class-variance-authority';

const drawerClasses =
  'c_drawer-dialog md:inset-[0_0_0_auto] md:max-w-[50dvw] md:min-w-[25dvw] md:rounded-l-md';
const bottomSheetClasses =
  'c_bottom-sheet-dialog max-md:inset-[auto_0_0_0] max-md:h-auto max-md:max-h-[85dvh] max-md:min-h-[35dvh] max-md:rounded-t-md';
export const dialogVariants = cva(
  'backdrop:bg-color-backdrop bg-color-background-base m-0 max-w-[900px] min-w-full flex-col',
  {
    variants: {
      variant: {
        default: 'min-h-full',
        bottomSheet: bottomSheetClasses,
        drawer: `${drawerClasses} max-md:min-h-full`,
        drawerBottomSheet: `${bottomSheetClasses} ${drawerClasses}`,
      },
      isOpen: { true: 'flex md:m-auto md:min-w-0' },
    },
    defaultVariants: {
      variant: 'default',
    },
    compoundVariants: [
      {
        variant: ['drawer', 'drawerBottomSheet'],
        isOpen: true,
        className: 'md:h-[100dvh] md:min-h-[100dvh]',
      },
      {
        variant: ['default', 'bottomSheet'],
        isOpen: true,
        className: 'md:h-fit md:min-h-0',
      },
    ],
  },
);
